import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";
import router from "@/router";

Vue.prototype.$termos = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      termosAddEdit: "new",
      add_termos: false,
      termos: [],
      filtros: [],
      loading_termos: false,
      loading_button: false,
      loading_select: false,
      cadastro: {
        enviar_email: false,
        idtermo: "",
        descricao: "",
        status: "",
        tipo_pessoa: "",
        texto: "",
        error: {
          descricao: [],
          status: [],
          tipo_pessoa: [],
          texto: [],
        },
      },
      filter: {
        descricao: "",
        tipo_pessoa: "",
        status: "",
      },
      tipo_pessoa: [
        { text: "PONTO DE VENDA", value: "PDV" },
        { text: "LOJA", value: "LOJA" },
        { text: "REDE DE AFILIADOS", value: "PROGRAMA_AFILIADOS" },
        //{ text: "CONSUMIDOR", value: "CONSUMIDOR" },
        //{ text: "AGENTE", value: "AGENTE" }
      ],
      status: [
        { text: "ATIVO", value: "ATIVO" },
        { text: "INATIVO", value: "INATIVO" },
      ],
      loading_tipo_pessoa: false,
      loading_status: false,
      open_termos: false,
      termos_lojista: "",
    };
  },
  computed: {
    storeIsActive() {
      if (this.$axios.getLocal("oe_user_info")?.data?.loja_status === "ATIVO")
        return true;
      else return false;
    },
  },
  isAdmin() {
    if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
      return true;
    return false;
  },
  methods: {
    /**
     * @description Método para listar termos
     * @returns {Promise} Retorna uma promise com o resultado da requisição
     */
    getTermos(filtros) {
      this.$axios
        .post(
          this.ENDPOINTS.LISTAR_TERMOS,
          JSON.stringify({ filtros: filtros })
        )
        .then(response => {
          const arrayOfObj = Object.entries(response).map(e => e[1]);

          this.termos = arrayOfObj;
          this.loading_termos = false;
          this.loading_button = false;
          this.loading_select = false;
        })
        .catch(error => {
          this.loading_termos = false;
          this.loading_button = false;
          this.loading_select = false;

          throw new Error(error);
        });
    },

    getTermosLojista() {
      this.$axios
        .get(this.ENDPOINTS.GET_TERMOS)
        .then(response => {
          this.termos_lojista = response;
        })
        .catch(error => {
          throw new Error(error);
        })
        .finally(() => (this.open_termos = true));
    },

    aceiteTermosLojista() {
      this.$axios
        .put(this.ENDPOINTS.ACEITE_TERMOS)
        .then(response => {
          if (response.sucesso) {
            this.$lojas_usuarios.getLogin(
              false,
              "",
              "",
              this.$axios.getLocal("oe_user_info")?.data?.loja,
              this.$axios.getCookie("oe_jwt")
            );
          }
        })
        .catch(error => {
          throw new Error(error);
        })
        .finally(() => {
          if (this.storeIsActive) return (this.open_termos = false);
          else {
            return setTimeout(() => {
              this.open_termos = false;
              router.push("/primeiros-passos");
            }, 1500);
          }
        });
    },

    /**
     * @description Método para cadastrar um novo termo
     * @param {Object} dados - Dados do termo
     * @returns {Promise} Retorna uma promise com o resultado da requisição, fecha o modal e chama o método de listagem para atualizar a lista
     */
    async cadastrarTermos() {
      this.loading_button = true;
      let dados = {
        descricao: this.cadastro.descricao,
        status: this.cadastro.status,
        tipo: this.cadastro.tipo_pessoa,
        texto: this.cadastro.texto,
        enviar_email: this.cadastro.enviar_email,
      };

      await this.$axios
        .post(this.ENDPOINTS.CADASTRAR_TERMOS, dados)
        .then(() => {
          this.limpaFormularioDeTermos();
          this.add_termos = false;
          this.getTermos();
        })
        .catch(() => {
          this.loading_button = false;
        });
    },

    /**
     * @description Método para alterar um termo
     * @param {Object} dados - Dados do termo
     * @returns {Promise} Retorna uma promise com o resultado da requisição, fecha o modal e chama o método de listagem para atualizar a lista
     */
    alterarTermos() {
      this.loading_button = true;
      let dados = {
        descricao: this.cadastro.descricao,
        status: this.cadastro.status,
        tipo: this.cadastro.tipo_pessoa,
        texto: this.cadastro.texto,
        enviar_email: this.cadastro.enviar_email,
      };

      this.$axios
        .put(this.ENDPOINTS.ALTERAR_TERMOS + this.cadastro.idtermo, dados)
        .then(() => {
          this.$axios.setLocal("confirmEditTermos", true);
          this.limpaFormularioDeTermos();
          this.add_termos = false;
          this.getTermos();
        })
        .catch(error => {
          this.loading_button = false;
          throw new Error(error);
        });
    },

    /**
     * @description Método para deletar um termo
     * @param {String} idtermo - ID do termo
     * @returns {Promise} Retorna uma promise com o resultado da requisição e chama o método de listagem para atualizar a lista
     */
    deletarTermo(idtermo) {
      this.$axios.delete(this.ENDPOINTS.DELETAR_TERMOS + idtermo).then(() => {
        this.getTermos();
      });
    },

    /**
     * @description Método para filtrar os termos
     * @param {Array} filtros - Filtros a serem aplicados
     * @returns {Promise} Retorna uma promise com o resultado da requisição
     */
    filtroTermos() {
      this.loading_termos = true;
      this.loading_button = true;
      this.loading_select = true;
      this.filtros = [];
      if (this.filter.descricao != "") {
        this.filtros.push({
          campo: "descricao",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.descricao,
        });
      }

      if (this.filter.tipo_pessoa != "" && this.filter.tipo_pessoa != null) {
        this.filtros.push({
          campo: "tipo",
          tipo: "string",
          orientacao: "=",
          valor: this.filter.tipo_pessoa,
        });
      }

      if (this.filter.status != "") {
        this.filtros.push({
          campo: "status",
          tipo: "string",
          valor: this.filter.status,
        });
      }

      let filtered = this.filtros;

      this.getTermos(filtered);
    },

    /**
     * @description Método para validar os campos do formulário de cadastro/alteração de um termo
     * @param {String} descricao - Descrição do termo
     * @param {String} status - Status do termo
     * @param {String} termosAddEdit - Tipo de cadastro (new ou edit)
     * @returns {Function} Retorna uma função alterarTermos ou cadastrarTermos
     */
    async validarCadastro() {
      // VALIDAÇÃO DOS DADOS CADASTRAIS
      if (this.cadastro.descricao == "") {
        this.$config.alert(
          "Preencha a descrição corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.descricao = "Preencha a descrição corretamente!";
        return;
      }

      if (this.cadastro.status == "") {
        this.$config.alert(
          "Selecione o status do termo!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.status = "Selecione o status do termo!";
        return;
      }

      if (this.cadastro.tipo_pessoa == "") {
        this.$config.alert(
          "Selecione o tipo de pessoa do termo!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.tipo_pessoa =
          "Selecione o tipo de pessoa do termo!";
        return;
      }

      if (this.cadastro.texto == "") {
        this.$config.alert(
          "Selecione o texto do termo!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.texto = "Selecione o texto do termo!";
        return;
      }

      if (this.termosAddEdit == "edit") {
        this.alterarTermos();
        return;
      }

      this.cadastrarTermos();
    },

    limpaFormularioDeTermos() {
      this.cadastro.descricao = "";
      this.cadastro.status = "";
      this.cadastro.tipo_pessoa = "";
      this.cadastro.texto = "";
      this.cadastro.error.descricao = "";
      this.cadastro.error.status = "";
      this.cadastro.error.tipo_pessoa = "";
      this.cadastro.error.texto = "";
      this.cadastro.enviar_email = false;
    },

    limpaFiltros() {
      this.filter.descricao = "";
      this.filter.tipo_pessoa = "";
      this.filter.status = "";
      this.termos = [];
    },
  },
});
